import React from 'react';
import c from 'classnames';
import useHeadlessResults from '../../../hooks/useHeadlessResults';
const SearchResultsHeadless = props => {
  const {
    className = '',
    children,
    loadAllPages = false
  } = props;
  const {
    infiniteHits,
    currentPageHits
  } = useHeadlessResults(loadAllPages);
  const classNames = c('Searchkit__SearchResultsHeadless', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, children && children(loadAllPages ? infiniteHits : currentPageHits));
};
export default SearchResultsHeadless;